import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const Search = () => {
  const [searchParams] = useSearchParams();
  
  useEffect(() => {
    const query = searchParams.get('q');
    if (query) {
      window.location.replace(`https://search.yahoo.com/search?p=${encodeURIComponent(query)}`);
    } else {
      window.location.replace('https://search.yahoo.com/search');
    }
  }, [searchParams]);

  return null;
};

export default Search;